import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import Popup from "../ui/Popup";
import { getActivityName } from "../../config/activities";

const QR_OPTIONS = { width: 300, margin: 2, color: { dark: "#000000", light: "#ffffff" } };

/** Payload encoded in the QR code. QRScanner reads these keys back, so keep them stable. */
export const buildQrPayload = (reservation, now = new Date()) => ({
  reservationId: reservation.id,
  teamName: reservation.team_name,
  timeSlot: reservation.time_slot,
  participantCount: reservation.team_number,
  password: reservation.password,
  activity: getActivityName(reservation.table),
  date: now.toLocaleDateString("cs-CZ"),
  timestamp: now.toISOString(),
});

const QRCodePopup = ({ isOpen, onClose, reservationData }) => {
  const [dataUrl, setDataUrl] = useState("");

  useEffect(() => {
    if (!isOpen || !reservationData) return undefined;
    let cancelled = false;
    setDataUrl("");
    QRCode.toDataURL(JSON.stringify(buildQrPayload(reservationData)), QR_OPTIONS)
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch((error) => console.error("Error generating QR code:", error));
    return () => {
      cancelled = true;
    };
  }, [isOpen, reservationData]);

  const downloadQrCode = () => {
    const link = document.createElement("a");
    link.download = `rezervace-${reservationData?.id ?? "qr"}.png`;
    link.href = dataUrl;
    link.click();
  };

  return (
    <Popup isOpen={isOpen} onClose={onClose} title="QR kód rezervace">
      <p>Naskenujte tento QR kód pro rychlý přístup k informacím o vaší rezervaci.</p>
      <div className="text-center">
        {dataUrl ? (
          <div className="qr-frame">
            <img src={dataUrl} alt="QR kód rezervace" />
          </div>
        ) : (
          <div className="qr-placeholder">
            <span className="spinner" />
            Generuji QR kód…
          </div>
        )}
      </div>

      {reservationData && (
        <div className="modal-box">
          <h4>Informace o rezervaci</h4>
          <div className="kv">
            <span>
              <b>Tým:</b> {reservationData.team_name}
            </span>
            <span>
              <b>Počet účastníků:</b> {reservationData.team_number}
            </span>
            <span>
              <b>Čas:</b> {reservationData.time_slot}
            </span>
            <span>
              <b>Heslo:</b> {reservationData.password || "Není k dispozici"}
            </span>
            <span>
              <b>Aktivita:</b> {getActivityName(reservationData.table)}
            </span>
          </div>
        </div>
      )}

      <div className="modal-actions">
        <button type="button" className="btn btn-ghost" onClick={onClose}>
          Zavřít
        </button>
        <button type="button" className="btn btn-marigold" onClick={downloadQrCode} disabled={!dataUrl}>
          Stáhnout QR kód
        </button>
      </div>
      <p className="already">QR kód obsahuje všechny informace o vaší rezervaci v Zemi vzpomínek.</p>
    </Popup>
  );
};

export default QRCodePopup;
